// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"XCore_TheComp__pvd45"};